import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useChangeCoverageOrcaCa } from './hooks/useChangeCoverageOrcaCa';
import { PolicyHeader } from '../PolicyHeader';

import pawImage from '../../../assets/changeCoverage/cat-paw.svg';
import { INSURANCE } from '../../navigation/routes.constants';
import { currencyFormat } from '../../../services/utils';

import { globalContactUsModalToggled } from '../../../actions';
import { formatDateByLanguage } from '../../../services/language.utils';
import { useUpToTop } from '../../../hooks';

import checkoutStyles from './css/ChangeCoverageOrcaCheckout.module.css';
import styles from './css/ChangeCoverageOrcaSuccess.module.css';

const PHONE_KEY = 'Call';

export const ChangeCoverageOrcaSuccess = () => {
  const { t } = useTranslation('changeCoverage');
  const history = useHistory();
  const dispatch = useDispatch();

  const store = useSelector(({ home }) => ({ home }));

  const {
    baseProducts,
    marketingChanelId,
    defaultPolicy,
    quotePreview,
    selectedProductCode,
  } = useChangeCoverageOrcaCa();

  const selectedProduct = useMemo(() => baseProducts?.find(({
    code,
  }) => code === selectedProductCode), [
    baseProducts,
    selectedProductCode,
  ]);

  const monthlyPremium = useMemo(() => quotePreview[selectedProductCode]
    ?.monthlyPreviewResults
    ?.reduce((prev, next) => prev + next.monthlyInstallment, 0) || 0, [
    quotePreview,
    selectedProductCode,
  ]);

  const phone = useMemo(() => {
    const info = store.home.contactInfo
      .find((item) => item.companyId === +marketingChanelId);

    const item =
      info?.ContactInformation.find(({ Name }) => Name === PHONE_KEY);

    return item?.Value || '';
  }, [marketingChanelId, store.home]);

  const onGoInsurance = () => {
    history.push(INSURANCE);
  };

  const onContactUs = () => {
    dispatch(globalContactUsModalToggled());
  };

  useUpToTop();

  return (
    <div className={checkoutStyles.checkout}>
      <h1>{t('checkout.title')}</h1>

      <div className={`Colors-${marketingChanelId} Width-full`}>
        <PolicyHeader
          company={+marketingChanelId}
          logoClass="Change-coverage-header-logo"
        />

        <div className={checkoutStyles.checkoutContainer}>
          <div className={checkoutStyles.success}>
            <img alt="" src={pawImage} />

            <h3>{t('submit.title')}</h3>

            <div className={checkoutStyles.successSummary}>
              <div className={checkoutStyles.successSummaryRow}>
                <span>{t('success.plan')}</span>

                <span>{selectedProduct?.display}</span>
              </div>

              <div className={checkoutStyles.successSummaryRow}>
                <span>{t('success.effectiveOn')}</span>

                <span>{formatDateByLanguage({
                  date: defaultPolicy?.PolicyEndDate,
                })}
                </span>
              </div>

              <div className={checkoutStyles.successSummaryRow}>
                <span>{t('success.total')}</span>

                <span>{currencyFormat({ value: monthlyPremium })}</span>
              </div>
            </div>

            <div className={styles.successFooter}>
              <span>{t('success.footerChanges', {
                date: formatDateByLanguage({
                  date: defaultPolicy?.PolicyEndDate,
                }),
                interpolation: { escapeValue: false },
              })}
              </span>
              {phone && (
                <span>{t('success.footerContact', { value: phone })}</span>
              )}
            </div>

            <div className="Row">
              <button
                className={checkoutStyles.backButton}
                onClick={onGoInsurance}
                type="button"
              >
                {t('success.back')}
              </button>

              <button
                className={checkoutStyles.contactButton}
                onClick={onContactUs}
                type="button"
              >
                {t('success.contactUs')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
